import React from 'react';
import { Button } from "react-bootstrap";
import { useStoreActions, useStoreState } from 'easy-peasy';
import axios from '../../services/axios';

import PropTypes from 'prop-types';

import './WelcomeBannerComponent.scss';

const WelcomeBannerComponent = ({ message, canClose  = true, setBanner = null, preview = false }) => {

    const { updateLastMessageClosed } = useStoreActions(actions => actions.users);
    const { apiData: { ACTIONS } } = useStoreState(state => state.actionSlugs);

    const clickCountUrl = ACTIONS.welcomeMessage?.countClick?.url?.replace('uniqueId', message.uniqueId);

    const closeForever = () => {
        setBanner && setBanner(null);
        updateLastMessageClosed({messageId : message.uniqueId})
    }

    if (message) {
        return (
            <div className={`${preview? "welcomePreview" : "welcomeBanner"} wb${message.category}`}>
                <span dangerouslySetInnerHTML={{ __html: message.content }}></span>
                {message.button &&
                    <Button
                        size="sm"
                        className="ml-4 extraButton"
                        variant="success"
                        onClick={() => {
                            axios.get(clickCountUrl);
                            const url = `${!message.button?.link?.startsWith('http') ? "http://" : ""}${message.button.link}`;
                            window.open(url, '_blank');
                        }}
                    >
                        {message.button.label}
                    </Button>
                }
                {canClose &&
                <span className='closeX' role="button" onClick={closeForever}>X</span>}
            </div>
        )
    }
}

WelcomeBannerComponent.propTypes = {
	message: PropTypes.object.isRequired,
    canClose: PropTypes.bool,
    setBanner: PropTypes.any,
    preview: PropTypes.bool,
};


export default WelcomeBannerComponent